import { normaliseProductAmendmentInputField, hasWarehouseSplit, resolveRelabellingFlags } from "src/helpers";
import { IdGenerator, ObjectCompare } from "src/utils";
import {
  AmendPurchaseOrderFormData,
  PatchPurchaseOrderRequestBody,
  Product,
  ProductAmendmentInputField,
  PurchaseOrder
} from "src/types";

export class AmendPurchaseOrderMapper {
  public static initAmendPurchaseOrderFormData(): AmendPurchaseOrderFormData {
    return {
      purchaseOrderId: "",
      productAmendments: [],
      estDeliveryDate: "",
      cancellationReason: ""
    };
  }

  public static productAmendmentInputFieldFromProducts(products: Product[]): ProductAmendmentInputField[] {
    return products.map((product) => {
      const warehouseSplit = hasWarehouseSplit(product);
      const { uk: requiresUkRelabelling, eu: requiresEuRelabelling } = resolveRelabellingFlags(product);
      return {
        id: product.id,
        name: product.name,
        size: product.size ?? "",
        barcode: product.barcode,
        requiresUkRelabelling,
        requiresEuRelabelling,
        isAnimalSku: product.isAnimalSku ?? false,
        isAnimalNonCertified: product.isAnimalNonCertified ?? false,
        fieldId: IdGenerator.generateUniqueElementId(product.id),
        amendedQty: product.quantity.toString(),
        orderQty: product.quantity.toString(),
        amendedUkQty: warehouseSplit ? (product.ukQuantity ?? 0).toString() : "",
        amendedEuQty: warehouseSplit ? (product.euQuantity ?? 0).toString() : "",
        hasWarehouseSplit: warehouseSplit
      };
    });
  }

  public static initAmendPurchaseOrderFormDataFromPurchaseOrder(
    purchaseOrder: PurchaseOrder
  ): AmendPurchaseOrderFormData {
    return {
      purchaseOrderId: purchaseOrder.id,
      productAmendments: AmendPurchaseOrderMapper.productAmendmentInputFieldFromProducts(purchaseOrder.products ?? []),
      estDeliveryDate: purchaseOrder.estimatedDeliveryDate?.split("T")[0] ?? "",
      cancellationReason: purchaseOrder.cancellationDetails?.cancellationReason ?? ""
    };
  }

  public static amendPurchaseOrderRequestBodyFromFormData(
    formData: AmendPurchaseOrderFormData,
    initialFormData?: AmendPurchaseOrderFormData
  ): PatchPurchaseOrderRequestBody {
    const productAmendmentsNoChange = ObjectCompare.isEqual(
      initialFormData?.productAmendments,
      formData.productAmendments
    );

    const normalisedProductAmendments = productAmendmentsNoChange
      ? undefined
      : formData.productAmendments.map(normaliseProductAmendmentInputField);

    const normalisedEstDeliveryDate =
      initialFormData?.estDeliveryDate === formData.estDeliveryDate ? undefined : formData.estDeliveryDate;

    return {
      products: normalisedProductAmendments,
      estDeliveryDate: normalisedEstDeliveryDate
    };
  }
}
